import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Prenotazioni from "./pages/Prenotazioni";
import { Clienti, Fornitori, Autisti } from "./pages/Anagrafiche";
import Flotta from "./pages/Flotta";
import Uber from "./pages/Uber";
import Incassi from "./pages/Incassi";
import Conteggi from "./pages/Conteggi";
import Turnistica from "./pages/Turnistica";
import Scadenze from "./pages/Scadenze";
import Sentinel from "./pages/Sentinel";
import GpsLive from "./pages/GpsLive";
import AirportIntelligence from "./pages/AirportIntelligence";
import EmailAI from "./pages/EmailAI";
import RicaricheEV from "./pages/RicaricheEV";
import RichiesteDriver from "./pages/RichiesteDriver";
import StoricoAutista from "./pages/StoricoAutista";
import ScambioServizi from "./pages/ScambioServizi";
import Impostazioni from "./pages/Impostazioni";
import Calendario from "./pages/Calendario";
import ClienteDetail from "./pages/ClienteDetail";
import DriverArea from "./pages/DriverArea";
import DriverRedirect from "./components/DriverRedirect";
import Messaggi from "./pages/Messaggi";
import Preventivi from "./pages/Preventivi";
import RichiesteTourvoyagers from "./pages/RichiesteTourvoyagers";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/driver" element={<ProtectedRoute><DriverArea /></ProtectedRoute>} />
          <Route element={<ProtectedRoute><DriverRedirect><Layout /></DriverRedirect></ProtectedRoute>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/prenotazioni" element={<Prenotazioni />} />
            <Route path="/preventivi" element={<Preventivi />} />
            <Route path="/richieste-tourvoyagers" element={<RichiesteTourvoyagers />} />
            <Route path="/calendario" element={<Calendario />} />
            <Route path="/clienti" element={<Clienti />} />
            <Route path="/clienti/:id" element={<ClienteDetail />} />
            <Route path="/fornitori" element={<Fornitori />} />
            <Route path="/autisti" element={<Autisti />} />
            <Route path="/autisti/:id/storico" element={<StoricoAutista />} />
            <Route path="/flotta" element={<Flotta />} />
            <Route path="/uber" element={<Uber />} />
            <Route path="/incassi" element={<Incassi />} />
            <Route path="/conteggi" element={<Conteggi />} />
            <Route path="/turnistica" element={<Turnistica />} />
            <Route path="/scadenze" element={<Scadenze />} />
            <Route path="/sentinel" element={<Sentinel />} />
            <Route path="/gps-live" element={<GpsLive />} />
            <Route path="/airport" element={<AirportIntelligence />} />
            <Route path="/email-ai" element={<EmailAI />} />
            <Route path="/ricariche-ev" element={<RicaricheEV />} />
            <Route path="/richieste-driver" element={<RichiesteDriver />} />
            <Route path="/scambio-servizi" element={<ScambioServizi />} />
            <Route path="/messaggi" element={<Messaggi />} />
            <Route path="/impostazioni" element={<Impostazioni />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
